export default {
  viewBox: "0 0 24 24",
  html: "<path d=\"M12.959 6.155v4.886h4.886V7.845L22 12l-4.155 4.155v-3.196h-4.886v4.886h3.196L12 22l-4.155-4.155h3.196v-4.886H6.155v3.196L2 12l4.155-4.155v3.196h4.886V6.155H7.845L12 2l4.155 4.155z\"/>"
};